import { render } from "./Footer.vue?vue&type=template&id=53167909&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=53167909&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-53167909"

export default script